module.exports = __webpack_public_path__ + "static/fluent-combobox-cb6ea19cbf0dce74ccc6fd7e11c962f1.png";